import React, { useEffect, useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useDispatch, useSelector } from 'react-redux';
import ShowProgress from '../ui/Backdrop';
import FloatButton from './FloatButton';
import BadgeAddNewPopup from '../badge/BadgeAddNewPopup';
import SideBarListStyles from '../../styles/SideBarListStyle';
import {
  getAllBadges,
  getBadgeTypeList,
  getSelectedBadgeType,
  showProgress,
} from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';

const SideBarListBadge = (props) => {
  const classes = SideBarListStyles();
  const dispatch = useDispatch();
  const [selectedType, setSelectedType] = useState('guide');
  const [IsAddnewBadgePopupOpen, setIsAddnewBadgePopupOpen] = useState(false);
  // const [badgeTypeList, setBadgeTypeList] = useState([]);
  const badgeTypeList = useSelector((state) => state.getBadgeTypeList.badgeTypeList);
  const value = props.value === undefined ? 0 : props.value;
  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];
  useEffect(() => {
    getBadgeList();
  }, []);
  const getBadgeList = async () => {
    await service
      .get(apiEndpoints.BADGES_TYPES)
      .then((response) => {
        dispatch(getBadgeTypeList('add', response));
        handleListItemClick(0, 'guide');
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const addNewBadge = () => {
    setIsAddnewBadgePopupOpen(true);
  };
  const closeAddNewBadge = () => {
    setIsAddnewBadgePopupOpen(false);
  };
  const handleListItemClick = async (event, type) => {
    setSelectedType(type);
    if (type === 'dose') {
      dispatch(getSelectedBadgeType('story'));
    } else {
      dispatch(getSelectedBadgeType(type.toLowerCase()));
    }
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.BADGE_BY_TYPE.replace('TYPE', type))
      .then((response) => {
        if (response) {
          dispatch(getAllBadges('add', response));
          dispatch(showProgress(false));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div className={classes.root} id="sidebar_list_badge" style={{ marginTop: '3vh' }}>
      <List component="nav" aria-label="secondary mailbox folder">
        {badgeTypeList?.map((data) => {
          const { type } = data;
          return (
            <div key={data.id} className={selectedType === type ? classes.highlightItem : ''}>
              <ListItem
                id={`list_id_${data.id}`}
                key={data.id}
                button
                selected={selectedType === type}
                className={classes.listStyling}
                onClick={(event) => handleListItemClick(event, data.type)}
              >
                <ListItemText
                  primary={
                    <div>
                      <p
                        className={`
                              ${selectedType === type ? classes.listTextSelected : classes.listTextNonSelected}
                            `}
                      >
                        {data.type !== 'dose'
                          ? `${data.type.charAt(0).toUpperCase() + data.type.slice(1)} Badges`
                          : 'Story Badges'}
                      </p>
                    </div>
                  }
                  secondary={
                    <div>
                      <div
                        className={selectedType === type ? classes.listSubTextSelected : classes.listSubTextNonSelected}
                      >
                        {data.count > 1 ? `${data.count.toString()} Badges` : `${data.count.toString()} Badge`}
                      </div>
                    </div>
                  }
                />
              </ListItem>
            </div>
          );
        })}
      </List>
      <FloatButton fabs={fabs} value={value} mainTabID={0} onaddNewJourney={addNewBadge} />
      {<ShowProgress />}
      {IsAddnewBadgePopupOpen && <BadgeAddNewPopup edit={false} close={closeAddNewBadge} />}
    </div>
  );
};

export default SideBarListBadge;
